import React, { useState } from 'react';
import { Button, Progress, Modal } from '@mantine/core';
import uploadFile from '../../../firebase/firebaseUploadFunction';
import { updateBrandImagesSC } from '../../../Constant/Api/Api';

const BrandImages = ({ subCategory, onClose }) => {
    const [imageUploadingLoader, setImageUploadingLoader] = useState(false);
    const [opened, setOpened] = useState(true);
    const [subCategoryImage, setSubCategoryImage] = useState(subCategory?.brandImagesSC);
    const id = subCategory._id;
    const updateCategoryImages = async (updatedImages) => {
        try {
            const response = await fetch(`${updateBrandImagesSC}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ id, brandImagesSC: updatedImages }),
            });

            if (!response.ok) {
                throw new Error('Failed to update category images');
            }

            const updatedCategory = await response.json();
            setSubCategoryImage(updatedCategory.brandImagesSC);
            console.log("updatedCategory----", updatedCategory);
        } catch (error) {
            console.error('Error updating category images:', error);
        }
    };

    const handleImageChange = (e) => {

        setImageUploadingLoader(true);
        uploadFile(e)
            .then((fireBaseUrl) => {
                const updatedImages = [...subCategoryImage, fireBaseUrl];
                updateCategoryImages(updatedImages);
                console.log("updatedImages", updatedImages);
                setImageUploadingLoader(false);
            })
            .catch((error) => {
                setImageUploadingLoader(false);
                console.error('Error:', error);
            });
    };

    const handleDeleteImage = (imageUrl) => {
        const updatedImages = subCategoryImage.filter((image) => image !== imageUrl);
        updateCategoryImages(updatedImages);
    };

    console.log("subCategoryImage---", subCategory.brandImagesSC);

    return (
        <div>
            <Modal opened={opened} onClose={() => { setOpened(false); onClose(); }} size="auto" title="Brand Image">
                <form className='space-y-2'>
                    {imageUploadingLoader ? (
                        <>
                            <span className='bg-red-50'>Please wait while the image is uploading...</span>
                            <Progress radius="xl" value={100} striped animated />
                        </>
                    ) : (
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            disabled={imageUploadingLoader}
                        />
                    )}
                </form>

                <div className="space-y-2">
                    {subCategoryImage?.map((image, index) => (
                        <div key={index} className="relative">
                            <img src={image} alt="Brand" className="w-full h-36 object-cover" />
                            <Button
                                className="absolute top-2 right-2"
                                color="red"
                                onClick={() => handleDeleteImage(image)}
                            >
                                Delete
                            </Button>
                        </div>
                    ))}
                </div>
            </Modal>
        </div>
    );
};

export default BrandImages;
